// extracted by mini-css-extract-plugin
export default {"navUl":"Nav_navUl__h47si"};